module.exports = __webpack_public_path__ + "media/images/plans/photo_studio/pickup-3-7e9f93b81453b87ace479d224987bb05.png";